import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getDropdownClasses = ({ dsf_open, dsf_breakout }) => {
  const classes = ["top-0", "left-0", "w-max", "isolate", "transition-opacity"];
  if (dsf_breakout) {
    classes.push("fixed");
  } else {
    classes.push("absolute");
  }
  if (!dsf_open) {
    classes.push("hidden");
  }
  return concatClasses(classes);
};
export {
  getDropdownClasses
};
